import { PHONE, locationSchema } from "../structured-data-core";

export function getBaltimoreStructuredData() {
  const url = "https://restorehair.com/locations/maryland/baltimore/";
  const description =
    "Find out about your hair transplant options in Baltimore with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Baltimore", "4000 East Pratt St, 8th Floor", "Baltimore", "MD", PHONE, url, description),
  ];
}
